module.exports = __webpack_public_path__ + "img/ic_32_sport_tennis-active.f92f34f0.svg";